module.exports = __webpack_public_path__ + "img/61.2191aead.png";